/**
 *
 * key
 *
 */

 const key = 'bWFuYWdlb2JzbGVhZA=='

 export default key
 